import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { withClientState } from 'apollo-link-state';
import resolversDefaults from './resolver';
import { logOut } from './utils';

const cache = new InMemoryCache({
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case 'loginSchemaData': return 'loginInfo';
      case 'updateUserSchemaData': return 'user';
      case 'getAllUserSchema': return 'userList';
      case 'getAllArtistSchema': return 'allArtists';
      case 'loader': return 'loader';
      case 'activeArtist': return 'activeArtist';
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

const stateLink = withClientState({
  cache,
  resolvers: resolversDefaults.resolvers,
  defaults: resolversDefaults.defaults,
});

const httpLink = new HttpLink({ uri: process.env.REACT_APP_API_URL });
const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    },
  }));
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors && graphQLErrors.length && graphQLErrors[0].extensions
    && graphQLErrors[0].extensions.code === 'UNAUTHENTICATED') {
    logOut();
  }
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'cache',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'none',
  },
};


const client = new ApolloClient({
  link: ApolloLink.from([errorLink, stateLink, authLink, httpLink]),
  cache,
  connectToDevTools: true,
  defaultOptions,
  resolvers: resolversDefaults.resolvers,
  // history: useHistory(),
});

export default client;
